import { __decorate } from "tslib";
import { Connect, Session } from '@genesislcap/foundation-comms';
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { foundationConnectionIndicatorStyles as styles } from './connection-indicator.styles';
import { foundationConnectionIndicatorTemplate as template } from './connection-indicator.template';
/**
 * @tagname %%prefix%%-connection-indicator
 */
export class ConnectionIndicator extends FoundationElement {
    constructor() {
        super(...arguments);
        this.showLabel = false;
        // could have been a boolean but might support more states in the future (connecting?)
        this.label = 'disconnected';
        this.colour = 'red';
    }
    connectedCallback() {
        super.connectedCallback();
        this.subscription = this.connect.isConnectedSubject.subscribe((connected) => {
            this.label = this.getLabel(connected);
            this.colour = connected ? 'green' : 'red';
        });
    }
    disconnectedCallback() {
        var _a;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    getLabel(connected) {
        if (!connected)
            return 'disconnected';
        const hostUrl = this.session.getSessionStorageItem('hostUrl');
        return `${hostUrl} ✔`;
    }
}
__decorate([
    Connect
], ConnectionIndicator.prototype, "connect", void 0);
__decorate([
    Session
], ConnectionIndicator.prototype, "session", void 0);
__decorate([
    attr({ mode: 'boolean', attribute: 'show-label' })
], ConnectionIndicator.prototype, "showLabel", void 0);
__decorate([
    observable
], ConnectionIndicator.prototype, "label", void 0);
__decorate([
    observable
], ConnectionIndicator.prototype, "colour", void 0);
/**
 * The Connection Indicator
 *
 * @public
 * @remarks
 * HTML Element: \<connection-indicator\>
 */
export const foundationConnectionIndicator = ConnectionIndicator.compose({
    baseName: 'connection-indicator',
    template,
    styles,
});
